module.exports = __webpack_public_path__ + "img/someMore2.b6071608.png";